const CHANNEL_NAME = "employeesfirst-session";
const TAB_ID = crypto.randomUUID();

const SESSION_NOTICES = {
  inactivity:
    "For your security, you were signed out after 15 minutes of inactivity.",
  "other-tab": "You were signed out in another Employees First tab.",
};

export function loginPathWithNotice(code) {
  return Object.hasOwn(SESSION_NOTICES, code) ? `/login?notice=${code}` : "/login";
}

export function readSessionNotice() {
  const code = new URLSearchParams(window.location.search).get("notice");
  return Object.hasOwn(SESSION_NOTICES, code ?? "") ? SESSION_NOTICES[code] : "";
}

export function broadcastSessionEvent(event) {
  const message = { ...event, tabId: TAB_ID, sentAt: Date.now() };
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(message);
    channel.close();
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Session broadcast unavailable:", error);
    }
  }
}

export function subscribeSessionEvents(onEvent) {
  let channel;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event) => {
      if (event.data?.tabId !== TAB_ID) onEvent(event.data);
    };
  } catch {
    channel = null;
  }
  return () => {
    channel?.close();
  };
}
